import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowRightIconSvg from './icon-arrow-right.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowRightIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowRightIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ArrowRightIcon = svgIconWrapper(SvgComponent);
